import FormField from '@cloudscape-design/components/form-field';
import CSDSelect, { SelectProps } from '@cloudscape-design/components/select';
import { get } from 'lodash';
import { Controller, useFormContext } from 'react-hook-form';

type Props = {
  name: string;
  options: SelectProps.Options;
  label?: string;
  defaultValue?: SelectProps.Option;
  description?: string;
  placeholder?: string;
  disabled?: boolean;
  stretch?: boolean;
  className?: string;
};

const Select = ({
  name,
  options,
  label,
  description,
  defaultValue = undefined,
  placeholder = '',
  disabled = false,
  stretch = false,
  className = '',
}: Props) => {
  const { control, formState } = useFormContext();

  return (
    <FormField
      stretch={stretch}
      description={description}
      label={label}
      className={className}
      errorText={get(formState.errors, name)?.message as string | undefined}
    >
      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue}
        render={({ field }) => (
          <CSDSelect
            {...field}
            placeholder={placeholder}
            disabled={disabled}
            selectedOption={field.value}
            onChange={({ detail }) => field.onChange(detail.selectedOption)}
            options={options}
          />
        )}
      />
    </FormField>
  );
};

export default Select;
